import { render, staticRenderFns } from "./InstaStreamEmbed.vue?vue&type=template&id=5cc0f6e2"
import script from "./InstaStreamEmbed.vue?vue&type=script&lang=js"
export * from "./InstaStreamEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports